import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Redirect, Route } from 'react-router-dom';

import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from 'utils/constants';

type OwnProps = {
  exact?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: React.ComponentType<any>;
  render?: (router: RouteComponentProps) => ReactNode;
  path: string;
};
type Props = OwnProps;

function AuthenticatedRoute({ component: Component, render, path }: Props) {
  const { loggedIn } = useSelector((state) => ({
    loggedIn:
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
      state.currentUser && !state.currentUser.isLoading && state.currentUser.id,
  }));
  return (
    <Route
      path={path}
      render={(router) => {
        if (!loggedIn) {
          return (
            <Redirect
              to={{
                pathname:
                  path === '/organizations/create' || path === '/post-a-listing'
                    ? SIGN_UP_TO_POST_URL_FOR_LOCALE[CURRENT_LOCALE]
                    : '/login',
                state: {
                  redirectTo: `${router.location.pathname}?${router.location.search}`,
                  flashMessage: {
                    type: 'LOGIN_REQUIRED',
                  },
                  title:
                    path === '/post-a-listing'
                      ? getText('Log in to Post a Listing')
                      : undefined,
                },
              }}
            />
          );
        }

        if (Component) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/jsx-props-no-spreading
          return <Component {...router} />;
        }

        if (render) {
          return render(router);
        }

        throw new Error('component or render prop is required');
      }}
    />
  );
}

// eslint-disable-next-line import/no-default-export
export default AuthenticatedRoute;
